export const CHAINE_GET_SUCCES = "CHAINE_GET_SUCCES";
export const CHAINE_GET_ECHEC = "CHAINE_GET_ECHEC";

export const CHAINE_UPDATE_SUCCES = "CHAINE_UPDATE_SUCCES";
export const CHAINE_UPDATE_ECHEC = "CHAINE_UPDATE_ECHEC";
